/* assets/giddy-freeship-popup.js
   Giddy — free-delivery + join popup.

     Guest / member (signed in, no orders) → "Free delivery over $80 + join for perks".
     Returning (signed in, has ordered)    → "Welcome back, here's 10% off" (IWANTMORE).

   Free shipping itself is handled automatically at checkout (the shipping app's
   "free over $80" rule), so this popup no longer applies a shipping code.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-giddy-fs-popup]');
  if (!root) return;

  var KEY_CLAIMED = 'giddyFreeship:state';        // 'claimed' retires the popup
  var KEY_SNOOZE = 'giddyFreeship:snoozeUntil';
  var KEY_SESSION = 'giddyFreeship:shownThisSession';
  var KEY_STARTED = 'giddyFreeship:startedAt';

  var scenario = root.getAttribute('data-scenario') || 'guest';
  var delayMs = (parseInt(root.getAttribute('data-delay'), 10) || 3) * 1000;
  var snoozeDays = parseInt(root.getAttribute('data-snooze-days'), 10) || 7;

  var card = root.querySelector('.giddy-fs-popup__card');
  var closeBtn = root.querySelector('[data-fs-close]');
  var claimBtns = root.querySelectorAll('[data-fs-claim]');
  var panels = root.querySelectorAll('[data-panel]');
  var lastFocused = null;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  function showPanel(name) {
    for (var i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-panel') !== name;
    }
    if (closeBtn) closeBtn.hidden = false;
  }
  function open(panel) {
    ssSet(KEY_SESSION, '1');
    lastFocused = document.activeElement;
    showPanel(panel);
    root.classList.add('is-open');
    document.addEventListener('keydown', onKeydown);
    if (card) card.focus();
  }
  function close(snooze) {
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKeydown);
    if (snooze) lsSet(KEY_SNOOZE, String(Date.now() + snoozeDays * 24 * 60 * 60 * 1000));
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }
  function onKeydown(e) { if (e.key === 'Escape') close(true); }

  if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });
  for (var c = 0; c < claimBtns.length; c++) {
    // Once they head off to claim the 10%, retire the popup; navigation via href.
    claimBtns[c].addEventListener('click', function () { lsSet(KEY_CLAIMED, 'claimed'); });
  }

  // ── decide whether / when to open ──
  if (lsGet(KEY_CLAIMED) === 'claimed') return;

  var snoozeUntil = parseInt(lsGet(KEY_SNOOZE), 10) || 0;
  if (Date.now() < snoozeUntil) return;
  if (ssGet(KEY_SESSION)) return;

  // Continuous countdown anchored to the first page view of the session.
  var startedAt = parseInt(ssGet(KEY_STARTED), 10) || 0;
  if (!startedAt) { startedAt = Date.now(); ssSet(KEY_STARTED, String(startedAt)); }
  var remaining = delayMs - (Date.now() - startedAt);
  if (remaining < 250) remaining = 250;

  setTimeout(function () {
    if (scenario === 'returning') open('welcome-returning');
    else open('promo');
  }, remaining);
})();
